import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => {
  return {
    value: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      marginTop: 5,
      wordBreak: 'break-word',
    },
  };
});

export default useStyles;
